export class Awards {
    constructor() {
        this.activeClass = "active";
        this.rotateSlideClass = "slides--rotate";
        this.startEvent = new Array("click", "touchend");
        this.initialSlideNumber = 1;
        this._touchstartX = 0;
        this._touchendX = 0;
        this.addEventHandlersForModels = (awardModels) => {
            this.mediaQueryMin1201.addEventListener("change", () => {
                if (this.mediaQueryMin1201.matches) {
                    this.handlerForMediaQuery(awardModels, 1201);
                }
            });
            this.mediaQueryMax1200.addEventListener("change", () => {
                if (this.mediaQueryMax1200.matches) {
                    this.handlerForMediaQuery(awardModels, 1200);
                }
            });
            this.startEvent.forEach((eventType) => {
                awardModels.forEach((model) => {
                    model?.addEventListener(eventType, (event) => {
                        event.preventDefault();
                        const activeAwardModel = document.querySelector(".subaru-awards__container .model.active");
                        activeAwardModel?.classList.remove(this.activeClass);
                        model.classList.add(this.activeClass);
                        this.deactiveTestimonialCarousel();
                        this.assignNewModelAwardsContainer(model.dataset.modelName);
                        this.getTestimonialCarousel();
                        if (this.testimonialCarousel &&
                            this.testimonialCarousel.querySelectorAll(".slide").length > 3) {
                            this.activateTesimonialCarousel();
                        }
                    });
                });
            });
        };
        this.startAutoPlayTestimonialCarousel = () => {
            const counterMax = this.slides.length - 1;
            window.playSlider = setInterval(() => {
                this.nextSlide();
                //spread out timing of two transitions so they don't happen simultaneously
                if (this.slideNumber === counterMax) {
                    setTimeout(() => {
                        this.skipCloneSlide();
                    }, 2000);
                }
            }, 4000);
        };
        const awardModels = document.querySelectorAll(".subaru-awards__container .model");
        this.setMediaQueries(awardModels);
        this.addEventHandlersForModels(awardModels);
        this.modelAwardsContainer = document.querySelector(".model-awards__container.active");
        this.getTestimonialCarousel();
        if (this.modelAwardsContainer) {
            this.modelAwardsContainer.classList.add(this.activeClass);
            if (this.testimonialCarousel &&
                this.testimonialCarousel.querySelectorAll(".slide").length > 3) {
                this.activateTesimonialCarousel();
            }
        }
    }
    getTestimonialCarousel() {
        this.testimonialCarousel = this.modelAwardsContainer?.querySelector(".subaru-awards__testimonials-carousel");
    }
    activateTesimonialCarousel() {
        this.slideNumber = this.initialSlideNumber;
        this.addTestimonialCarouselEventListeners();
        this.initializeTestimonialCarousel();
        this.startAutoPlayTestimonialCarousel();
    }
    setMediaQueries(awardModels) {
        this.mediaQueryMin1201 = window.matchMedia("(min-width: 1201px)");
        this.mediaQueryMax1200 = window.matchMedia("(max-width: 1200px)");
        if (this.mediaQueryMin1201.matches) {
            this.handlerForMediaQuery(awardModels, 1201);
        }
        else if (this.mediaQueryMax1200.matches) {
            this.handlerForMediaQuery(awardModels, 1200);
        }
    }
    handlerForMediaQuery(awardModels, mediaQuerySize) {
        awardModels.forEach((model) => {
            this.styleModelImages(model, mediaQuerySize);
        });
    }
    styleModelImages(model, mediaQuerySize) {
        const screenSize = mediaQuerySize === 1200 ? "Mobile" : "Desktop";
        const datasetBackgroundPosition = `backgroundPosition${screenSize}`;
        const datasetBackgroundSize = `backgroundSize${screenSize}`;
        const modelImg = model.querySelector(".model__image");
        const modelIsSubaru = "isSubaru" in modelImg.dataset;
        if (modelIsSubaru) {
            modelImg.style.backgroundSize =
                modelImg.dataset[datasetBackgroundPosition];
        }
        else {
            modelImg.style.backgroundPosition =
                modelImg.dataset[datasetBackgroundPosition];
            if (datasetBackgroundSize in modelImg.dataset) {
                modelImg.style.backgroundSize = modelImg.dataset[datasetBackgroundSize];
            }
        }
    }
    deactiveTestimonialCarousel() {
        if (this.testimonialCarousel &&
            this.testimonialCarousel.querySelectorAll(".slide").length > 3) {
            this.stopAutoPlayTestimonialCarousel();
            this.removeActiveTestimonialCarouselStyling();
            this.removeTestimonialCarouselEventListeners();
            this.testimonialCarousel.classList.remove(this.activeClass);
        }
    }
    addTestimonialCarouselEventListeners() {
        this.prevBtn = this.testimonialCarousel.querySelector(".subaru-awards__testimonials-carousel .prev");
        this.nextBtn = this.testimonialCarousel.querySelector(".subaru-awards__testimonials-carousel .next");
        this.slideContainer = this.testimonialCarousel.querySelector(".subaru-awards__testimonials-carousel .slides");
        this.slides = this.slideContainer.querySelectorAll(".slides .slide");
        this.slideContainer.addEventListener("transitionend", () => {
            this.skipCloneSlide();
        });
        this.testimonialCarousel.addEventListener("mouseover", () => {
            this.stopAutoPlayTestimonialCarousel();
        });
        this.testimonialCarousel.addEventListener("mouseout", () => {
            this.startAutoPlayTestimonialCarousel();
        });
        this.testimonialCarousel.addEventListener("touchstart", (e) => {
            this.stopAutoPlayTestimonialCarousel();
            this._touchstartX = e.changedTouches[0].screenX;
        });
        this.testimonialCarousel.addEventListener("touchend", (e) => {
            this._touchendX = e.changedTouches[0].screenX;
            this.swipeSlide();
            this.startAutoPlayTestimonialCarousel();
        });
        const resizeCarousel = new ResizeObserver(() => {
            this.slideWidth = this.slides[0].clientWidth;
        });
        resizeCarousel.observe(this.testimonialCarousel);
        this.startEvent.forEach((eventType) => {
            this.nextBtn?.addEventListener(eventType, () => {
                this.nextSlide();
            });
            this.prevBtn?.addEventListener(eventType, () => {
                this.prevSlide();
            });
        });
    }
    nextSlide() {
        if (this.slideNumber < this.slides.length - 1) {
            this.slideContainer.classList.add(this.rotateSlideClass);
            this.slideNumber++;
            this.rotateSlide();
            this.removeActiveDot();
            const dotNumber = this.slideNumber <= this.slides.length - 2 ? this.slideNumber : 1;
            this.addActiveDot(dotNumber);
        }
    }
    prevSlide() {
        if (this.slideNumber > 0) {
            this.slideContainer.classList.add(this.rotateSlideClass);
            this.slideNumber--;
            this.rotateSlide();
            this.removeActiveDot();
            const dotNumber = this.slideNumber === 0 ? this.slides.length - 2 : this.slideNumber;
            this.addActiveDot(dotNumber);
        }
    }
    skipCloneSlide() {
        const slideClassName = this.slides[this.slideNumber].className.toLocaleLowerCase();
        if (slideClassName.includes("clone")) {
            this.slideNumber = slideClassName.includes("first")
                ? this.slides.length - this.slideNumber
                : this.slides.length - 2;
            this.slideContainer.classList.remove(this.rotateSlideClass);
            this.rotateSlide();
        }
    }
    initializeTestimonialCarousel() {
        this.removeActiveDot();
        this.stopAutoPlayTestimonialCarousel();
        this.slideNumber = this.initialSlideNumber;
        this.slideWidth = this.slides[0].clientWidth;
        this.rotateSlide();
        this.initializeDots(this.slideNumber);
    }
    initializeDots(slideNumber) {
        const firstDot = this.testimonialCarousel.querySelector(`.dot[data-dot-number="${slideNumber.toString()}"]`);
        firstDot?.classList.add(this.activeClass);
    }
    removeActiveDot() {
        const currentDot = this.getActiveDot();
        currentDot.classList.remove("active");
    }
    addActiveDot(dotNumber) {
        const activeDot = this.testimonialCarousel.querySelector(`.dot[data-dot-number="${dotNumber.toString()}"]`);
        activeDot?.classList.add("active");
    }
    getActiveDot() {
        return this.testimonialCarousel.querySelector(".dot.active");
    }
    rotateSlide() {
        this.slideContainer.style.transform =
            "translateX(" + -this.slideWidth * this.slideNumber + "px)";
    }
    removeActiveTestimonialCarouselStyling() {
        this.slideContainer.classList.remove(this.rotateSlideClass);
        this.slideContainer.style.transform = "none";
    }
    removeTestimonialCarouselEventListeners() {
        this.removeEventListeners(this.testimonialCarousel);
        this.removeEventListeners(this.slideContainer);
        this.removeEventListeners(this.prevBtn);
        this.removeEventListeners(this.nextBtn);
    }
    stopAutoPlayTestimonialCarousel() {
        if (window.playSlider) {
            clearInterval(window.playSlider);
        }
    }
    removeEventListeners(element) {
        const oldElement = element;
        const newElement = oldElement?.cloneNode(true);
        oldElement?.parentNode?.replaceChild(newElement, oldElement);
    }
    assignNewModelAwardsContainer(selectedModelName) {
        this.modelAwardsContainer?.classList.remove(this.activeClass);
        this.modelAwardsContainer = document.querySelector(`.model-awards__container.award-models--${selectedModelName}`);
        this.modelAwardsContainer?.classList.add(this.activeClass);
    }
    swipeSlide() {
        if (this._touchendX < this._touchstartX) {
            this.nextSlide();
        }
        else if (this._touchendX > this._touchstartX) {
            this.prevSlide();
        }
    }
}
window.DoUtility.SelfInstantiateOnLoad(Awards);
